import { Skeleton } from 'shared/ui/skeleton';
export const BalanceSkeleton = () => {
  return <Skeleton className="h-5 w-24" data-sentry-element="Skeleton" data-sentry-component="BalanceSkeleton" data-sentry-source-file="balance-skeleton.tsx" />;
};